import React from 'react';

const PrivacyPolicy = () => (
  <div>
    <h1>Privacy Policy</h1>
    <p>
      This Privacy Policy sets out how Fishbrain AB, Reg. No 556796-5370, a company duly
      incorporated and organised under the laws of Sweden, having its registered address at
      Jakobsbergsgatan 31, 111 44 Stockholm, Sweden, collects, uses and shares information that we
      obtain as a result of your use of the Fishbrain application, http://www.fishbrain.com, our
      other applications and tools, and any related services (collectively the
      &quot;Services&quot;). By using or accessing the Services, you confirm that you have received
      this Privacy Policy and that you agree to the use of your information as explained in this
      Privacy Policy. If you do not agree, please do not use the Services.
    </p>
    <h2>1. Personal Data</h2>
    <h3>Personal Information Collected</h3>
    <p>
      Fishbrain&apos;s website and mobile applications are services for logging, tracking, and
      sharing sport fishing related information. To provide these services we may collect and store
      information about you. The type of personal information we may collect includes name,
      username, password, email address, telephone number, address, gender, location data, payment
      information (from Google and Apple), as well as any other user generated content that may be
      personally identifiable such as photos and videos. When you use our application, we also
      collect information such as content that you browsed and the date and duration of your use.
    </p>
    <h3>Use of Personal Information</h3>
    <p>
      Your privacy is important to us. Any data collected and/or stored by us is used to provide the
      Services and improve our Services, develop new products and Services, conduct statistical
      analysis, provide information to research partners, analyze your use and personalize the
      Services. We may also use your information for marketing purposes for which we will ask
      consent from you.
    </p>
    <h3>Recipients of Personal Information</h3>
    <p>
      Any personal data collected from you may only be transferred outside the European Union/the
      European Economic Area by observing applicable privacy regulations and ensuring your privacy
      rights are protected.&nbsp;
    </p>
    <p>
      In addition to the things mentioned in this policy, we also share your information with
      service providers to perform functions and process user data and help provide our Services,
      consistent with this Privacy Policy. For instance, we work with Amazon Web Services to host
      and process our data and we work with various analytics providers to help us understand the
      use of our Services to build a better product. Where a third party processes user data on our
      behalf, it is subject to the security and confidentiality obligations consistent with this
      Privacy Policy and applicable law.
    </p>
    <p>
      When you submit information as part of a competition or interact with us on social media, we
      may publish the information you submitted with your name in our app and social media channels.
      <br />
      In addition, we may share your personal information with third parties, such as other
      companies within the same group or in the event that we sell or buy any business or assets.
    </p>
    <p>
      By using our service, you acknowledge and agree that your personal data may be hosted and/or
      transferred to such recipients both within and outside the European Economic Area. To comply
      with regulations, laws or any authority requests, we may disclose your information to
      authorities or other officials, without your prior consent.
    </p>
    <h2>2. Your rights</h2>
    <p>
      You have certain rights in relation to the personal information that we hold about you. Those
      rights include:
    </p>
    <p>
      <strong>Right of access:</strong> You have a right to know what information we hold about you
      and to have the information communicated to you. In case you want to exercise this right,
      please contact us and let us know what information you would like to receive. We may need to
      verify your identity before we provide you with any information. Note that we may not be able
      to provide all the information you ask for, especially if the information includes personal
      information about another person.
    </p>
    <p>
      <strong>Data Portability:</strong> We will try to respond to any request as soon as possible,
      but we will always do so within 30 days of receipt of your request and evidence of ID. You
      have the right to receive your personal data in machine-readable format.
    </p>
    <p>
      <strong>Data rectification/deletion:</strong> You have a right to have some of the personal
      information that we hold about you rectified or deleted. Should you wish to have any
      information about you rectified or deleted, please contact us at support@fishbrain.com. Where
      we delete personal information about you, we may still retain some or all of that information
      for other purposes such as maintaining financial records, protecting or enforcing legal
      rights, or for technical reasons such as maintaining our database integrity. We may also
      retain your information in an anonymized form.
    </p>
    <p>
      <strong>Account deactivation:</strong> If you have an account with us and object to our
      processing of your personal data or you want us to deactivate your account, you can ask us to
      deactivate it by contacting us support@fishbrain.com . We may ask you for other information
      before we are able to deactivate your account.
    </p>
    <p>
      <strong>Withdrawal of consent:</strong> If you have selected to receive direct marketing
      communications from us, and you want to stop receiving it, you can click on the opt out link
      in the marketing communication sent.
    </p>
    <h2>3. Security</h2>
    <p>
      &nbsp;We will use commercially reasonable efforts to safeguard the confidentiality of your
      personal information. However, we cannot be held liable for any loss of or disclosure of data
      or any losses or damages incurred due to errors in transmission or unauthorized or unlawful
      acts of third parties or your decision to disclose your personal information.
    </p>
    <h2>4. Data retention</h2>
    <p>
      We store profile data like name, username, password, email address, telephone number, address
      and gender and the content created by you such as posts, photos, and videos, as long as it is
      necessary for the provision of our services to you. If you wish us to discontinue storing this
      data, please contact us at support@fishbrain.com.
    </p>
    <h2>5. Cookies</h2>
    <p>
      By using the Services you agree to our use of cookies on the Services. Cookies are small text
      files that websites send to your computer to uniquely identify your browser or to store
      information or settings in your browser. The following cookies are used at
      http://www.fishbrain.com:
    </p>
    <ul>
      <li>
        Lang - the cookie contains the preferred language of the user. It expires after 1 year.
      </li>
      <li>
        MemberID - the cookie contains the ID of the current user. You can choose if you want it to
        be a session cookie (in which case it would be deleted when the browser is closed) or a
        persistent cookie, which will then expire after 30 days.
      </li>
      <li>
        MemberPassword - the cookie contains authentication information for the current user. You
        can choose if you want it to be a session cookie (in which case it would be deleted when the
        browser is closed) or a persistent cookie, which will then expire after 30 days.
      </li>
      <li>
        We also use Google Analytics to collect visitor statistics on the website. Several cookies
        are created by Google and described in further detail here:
        developers.google.com/analytics/devguides/collection/analyticsjs/cookie-usage
      </li>
    </ul>
    <p>
      You can choose not to store cookies by turning acceptance of cookies off in the settings of
      your web browser used to access the Services. You can also delete cookies. Please note,
      however, that without cookies you may not be able to use all of the features of the Services.
    </p>
    <h2>6. Contact us</h2>
    <p>
      If you want to contact us about any of the matters in relation to this privacy policy please
      email support@fishbrain.com. If you have any complaints regarding the processing of your
      personal data, you can also contact the supervisory authority.
    </p>
  </div>
);

// Needs default to auto load correct file

export default PrivacyPolicy;
